import Resizer from 'react-image-file-resizer'

// eslint-disable-next-line import/prefer-default-export
export const resizeFile = (
  file: File,
  maxX: number,
  maxY: number,
  type: 'JPEG' | 'PNG',
): Promise<File> => new Promise((resolve) => {
  Resizer.imageFileResizer(
    file,
    maxX, // New image max width (ratio is preserved)
    maxY, // New image max height (ratio is preserved)
    type,
    100, // Quality out of 100
    0, // Rotation
    // we know we are getting a file because we specify 'file' below
    // eslint-disable-next-line no-type-assertion/no-type-assertion
    (resizedFile) => resolve(resizedFile as File),
    'file',
  )
})
